import totalOffsetTop from "../../helpers/totalOffsetTop";

class CustomJumplink extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const link = this.querySelector("a");
    const target = document.querySelector(link.getAttribute("href"));

    if (!target) {
      this.style.display = "none";
    }

    this.addEventListener("click", (e) => {
      const link = this.querySelector("a");
      const target = document.querySelector(link.getAttribute("href"));
      console.log(`target`, target);
      if (!target) return;

      e.preventDefault();

      window.scroll({
        top: totalOffsetTop(target) - 60,
        behavior: "smooth",
      });

      target.tabIndex = "-1";
      target.focus();
    });
  }

  disconnectedCallback() {}
}

if (!customElements.get("custom-jumplink")) {
  customElements.define("custom-jumplink", CustomJumplink);
}
